import { Fragment } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import CreatePost from "../Post/CreatePost";
import Notifications from "./Notifications";
import Logo from "../Layout/Logo";
import Divider from "@material-ui/core/Divider";

// Material ui stuff
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Button from "@material-ui/core/Button";

// custom components
import MyButton from "../../util/MyButton";
import Menu from "../Menu/Menu";

//Mui Icons
import HomeIcon from "@material-ui/icons/Home";

const Navbar = ({ user }) => {
  return (
    <AppBar
      color="inherit"
      position="fixed"
      style={{
        borderBottom:"1px solid #dbdbdb",
      }}
    >
      <Toolbar
        className="nav-container"
      >
        <Logo />
        {user.authenticated ? (
          <div className="nav-icons">
            <Fragment>
              <Link to="/home">
                <MyButton tip="Home">
                  <HomeIcon />
                </MyButton>
              </Link>
              <CreatePost />
              <Notifications />
              <Menu user={user} />
            </Fragment>
          </div>
        ) : (
          <div style={{ display: "flex" }}>
            <Fragment>
              <Button
                style={{
                  marginRight: "0.5rem",
                  width: "auto",
                  height: "auto",
                }}
                variant="outlined"
                color="primary"
                component={Link}
                to="/login"
                size="small"
              >
                Login
              </Button>
              <Button
                style={{
                  marginRight: "0.5rem",
                  color: "white",
                  width: "auto",
                  height: "auto",
                }}
                variant="contained"
                color="primary"
                component={Link}
                to="/signup"
                size="small"
              >
                Sign up
              </Button>
            </Fragment>
          </div>
        )}
      </Toolbar>
    </AppBar>
  );
};

Navbar.propTypes = {
  authenticated: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps)(Navbar);
